// extracted by mini-css-extract-plugin
export default {"sider":"Yafi18mh30f0udh_67gm","logo":"m3DjeirwRyDlpQQlP1ph","menu":"P4SXNsz87bQyTvoXYOGQ","layoutMain":"aZLI6iO9cPgHVt0W56mA","content":"D4ymVhDAGtvU6EHBsCDf"};